import { z } from 'zod'

export const bankAccountFormSchema = z.object({
  name: z.string().min(1, { message: 'Název je povinný' }),
  accountNumber: z.string().optional().nullable(),
  bankCode: z.string().optional().nullable(),
  iban: z.string().optional().nullable(),
  bic: z.string().optional().nullable(),
  isDefault: z.boolean(),
})

export type BankAccountFormValues = z.infer<typeof bankAccountFormSchema>
